/**
 * Whether Grid `fetchCallback` should call {@link TableRemoteFetchBridge}
 * (`getCardData` paging) instead of client-slicing a bound `[tableData]` payload.
 *
 * Editor preview binds `[tableData]` for display, but create/edit cards still have a
 * real `cardId` in CardState — they must use remote paging like the page canvas.
 * Static/Storybook demos without a cardId keep client-side slicing only.
 */
export function tableCardUsesRemoteFetch(
	cardId: string | undefined | null
): boolean {
	return typeof cardId === 'string' && cardId.trim().length > 0;
}
